module.exports = __webpack_public_path__ + "static/media/logo_on_blue_bg.de46bfbc.png";